interface ValidationIconOverlayScope extends ng.IScope {
  model: any;
}

export default function ValidationIconOverlay() {
  'ngInject';

  // TODO: pass in the icon type that will be displayed e.g. "alert"
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (
      scope: ValidationIconOverlayScope,
      element,
      atts,
      ngModelCtrl
    ) {
      scope.model = ngModelCtrl;

      // Use insertAfter(element) rather than element.after() so that it returns the new element (rather than the original)
      var overlay = $(
        '<span aria-hidden="true" class="form-control-feedback fa fa-exclamation-triangle"></span>'
      ).insertAfter(element);

      ngModelCtrl.$touched
        ? overlay.addClass('ng-touched')
        : overlay.addClass('ng-untouched');

      ngModelCtrl.$valid
        ? overlay.addClass('ng-valid')
        : overlay.addClass('ng-invalid');

      // overlay.toggleClass seemed more straightforward, but it did not always toggle the class correctly

      scope.$watch(
        () => ngModelCtrl.$touched,
        function (newVal, oldVal) {
          if (oldVal !== newVal) {
            // console.log('touched changed to ' + newVal);

            newVal
              ? overlay.addClass('ng-touched')
              : overlay.removeClass('ng-touched');
            newVal
              ? overlay.removeClass('ng-untouched')
              : overlay.addClass('ng-untouched');

            // For some reason, we need to trigger the valid check on touched change, even though we have the $valid watch
            ngModelCtrl.$valid
              ? overlay.addClass('ng-valid')
              : overlay.removeClass('ng-valid');
            ngModelCtrl.$valid
              ? overlay.removeClass('ng-invalid')
              : overlay.addClass('ng-invalid');
          }
        }
      );

      scope.$watch(
        () => ngModelCtrl.$valid,
        function (newVal, oldVal) {
          if (oldVal !== newVal) {
            // console.log('valid changed to ' + newVal);

            newVal
              ? overlay.addClass('ng-valid')
              : overlay.removeClass('ng-valid');
            newVal
              ? overlay.removeClass('ng-invalid')
              : overlay.addClass('ng-invalid');
          }
        }
      );
    }
  };
}
